import React, { Component } from 'react';

//Custom Components
import Header from '../components/Header'
import SingleAppShowCase from '../components/SingleAppShowcase'

// Images for Demo
import camoflix from '../img/camoflix-screenshot.png'
import demo from '../img/linerfinder-screenshot.png'
import pssc from '../img/ps-screenshot.png'
import invosc from '../img/invo-screenshot.png'
import selahsc from '../img/selah-screenshot.png'

// Images for Logo
import camoflixLogo from '../img/camoflix-logo.png'
import linerFinderLogo from '../img/liner-finder-logo.png'
import PSLogo from '../img/ps-logo.png'
import invoLogo from '../img/invo-logo.png'
import SELAHLogo from '../img/logo-selah-white.png'


class AppDemo extends Component {

  render() {
    return (
      <div
        className="align-items-center"
      >
      <Header
        title="Midwestern"
      />
        <SingleAppShowCase
          backgroundColor={'#FFF'}
          appTitle={"PowerShades"}
          appLogo={PSLogo}
          logoWidth={"50%"}
          appDescription="Powershades is a mobile platform for clients of the motorized shades company to be able to quickly modify
                          their shades from anywhere. Using the application grants users the ability to connect new shades, 
                          easily group shades together for simplistic scheduling and monitoring."
          appVisual={pssc}
          appStoreLink="https://apps.apple.com/us/app/powershades/id1509601683#?platform=iphone"
        /> 
        <SingleAppShowCase
          backgroundColor={'#E0E0E0'}
          appTitle={"Invo"}
          appLogo={invoLogo}
          logoWidth={"70%"}
          appDescription="Invo Solutions creates video banking software for various financial institutions that inherits 
                          from one core codebase. I rebuilt the mobile platform from the ground up using React Native. I
                          designed the user interface and added a host of new features to end on a product that is more intuitive
                          and much more modern. The rebuilt mobile app has resulted in many new sales ahead of it's beta in Q4 2021"
          appVisual={invosc}
          appStoreLink="https://apps.apple.com/us/app/invo-video-chat/id1447572627"
          googlePlayLink="https://play.google.com/store/apps/details?id=com.invosolutions.demo.videochat&hl=en_US&gl=US"
        />  
        <SingleAppShowCase
          backgroundColor={'#EFCA3D'}
          appTitle={"CamoFlix"}
          appLogo={camoflixLogo}
          logoWidth={"45%"}
          appDescription="CamoFlix is an online community built for the outdoor lover in all of us. 
                  Watch and upload hours of the highest quality content based around hunting and any other outdoor hobby you are into.
                  With a press of a button, you can get involved in the community forums, 
                  message your favorite content creators and edit your profile and subscriptions."
          appVisual={camoflix}
          appStoreLink="https://apps.apple.com/us/app/camoflix/id1434464573"
          googlePlayLink="https://play.google.com/store/apps/details?id=com.midwestern.camoflix&hl=en_US"
        />
        <SingleAppShowCase
          backgroundColor={'#13A7FF'}
          appTitle={"LinerFinder"}
          appLogo={linerFinderLogo}
          logoWidth={"50%"}
          lightText={true}
          appDescription="The Napco Bag App is made from the ground up to make the lives of Napco sales representatives 
                          and their superiors more efficient. This application grants the user the ability to submit a new quote by taking a 
                          photo in app or uploading a photo from their camera roll. On top of creating new quotes, 
                          managing existing quotes couldn't be any easier."
          appVisual={demo}
          appStoreLink="https://apps.apple.com/us/app/linerfinder/id1338562891"
        />
        <SingleAppShowCase
          backgroundColor={'#0F0F0F'}
          appTitle={"SELAH"}
          appLogo={SELAHLogo}
          logoWidth={"30%"}
          appDescription="SELAH is an app from CIY that allows christians to jump into medatative studies on the Bible 
                          through the use of text, audio and video."
          appVisual={selahsc}
          lightText={true}
          appStoreLink="https://apps.apple.com/us/app/selah-devos/id1383328814"
          googlePlayLink="https://play.google.com/store/apps/details?id=com.ciy.selah&hl=en_US&gl=US"
        />
      </div>
    );
  }
}

export default AppDemo;



// WEBPACK FOOTER //
// ./src/screens/Apps.js